<template>
  <div class="page">
    <div class="header">
      <div class="logo" @click="$router.push('/')">
        <img src="@/assets/logo.png" alt="">
        <div>TEAM MISFIT</div>
      </div>
      <nav>
        <router-link to="/posts">Posts</router-link>
        <router-link to="/contact">Contact</router-link>
      </nav>
    </div>
    <router-view/>
    <div class="footer">
      <div>Copyright © 2025 Team Misfit<br>All rights reserved</div>
      <!--<div>Website created by Wiktor Ciepłowski<br><a href="mailto:wiktor-cie@wp.pl">wiktor-cie@wp.pl</a></div>-->
    </div>
  </div>  
</template>

<style lang="scss">
@use "@/style.scss" as *;

.header {
  display: flex;
  flex-direction: row;
  padding: 30px;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px $secondary;
  .logo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-family: jersey;
    font-size:30px;
    cursor: pointer;
    img {
      width: 30px;
    }
  }
  nav {
    display: flex;
    flex-direction: row;
    gap: 30px;
    font-size:18px;
    a {
      font-weight: bold;
      text-decoration: none;
      color: $text;

      &.router-link-exact-active {
        color: $accent;
      }
    }
    a:hover {
      text-decoration: underline;
    }
  }
}

.container {
  max-width: 800px;
  min-height: 100%;
  padding: 30px 0;
  margin: auto;
}

.footer {
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-between;
  padding: 20px;
  border-top: solid 1px $secondary;
  color: $text2;
  font-size: 16px;
  margin-top: 60px;
}
.page {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 60px auto 140px;
  min-height: 100vh;
}
@media screen and (max-width: 580px) {
  .header {
    padding: 20px;
    .logo {
      font-size: 24px;
      img {
        width: 24px;
      }
    }
    nav {
      font-size: 16px;
      gap: 20px;
    }
  }
  .footer {
    font-size: 14px;
    flex-direction: column;
    gap: 10px;
  }
  .page {
    grid-template-rows: 60px auto 180px;
  }
  .container {
    width: calc(100% - 40px);
    padding: 0 20px;
  }
}

</style>
